import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter, fromEvent, map, Observable, shareReplay, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
/**
 * Service-Klasse, die für die Angular-App die Kommunikation mit der einbettenden Anwendung (21c) kapselt.
 * Für die Angular-Komponenten ist es somit transparent,
 * ob die Kommunikation via Query-Parameter oder Message-Posting erfolgt.
 * BEGRÜNDUNG: Da diese Service-Klasse für die Kommunikation mit einer firmeninternen Anwendung ist,
 * gibt es keine entsprechende AFO, die die Nutzung dieser vorschreibt.
 */
export class FrameService {
  /**
   * Observable, welches von außen kommende Werte für den Homeserver-Host bereitstellt.
   * Der letzte Wert wird gebuffert, sodass immer ein Wert synchron beim subscriben übergeben wird,
   * sofern überhaupt jemals ein Wert von außen definiert wurde.
   */
  private readonly homeserverHostObservable: Observable<string> | undefined;

  constructor() {
    const route = inject(ActivatedRoute);

    if (window.top === window.self) {
      console.log('Client ist nicht embedded');
      return;
    }

    console.log('Client ist embedded: Registriere Listener');

    this.homeserverHostObservable = fromEvent<MessageEvent<{ homeserverHost?: string }>>(window, 'message').pipe(
      map(event => event.data.homeserverHost),
      startWith(route.snapshot.queryParamMap.get('homeserverhost')),
      map(value => value ?? ''),
      filter((host: string) => !!host),
      shareReplay(1)
    );
  }

  /**
   * Registriert einen Callback für von außen kommende Werte für den Host des Homeservers.
   * Der zuletzt eingetroffene Wert steht sofort synchron zur Verfügung,
   * sofern jemals ein Wert eingetroffen ist.
   *
   * @param callback Bearbeitet neu eintreffende Werte für den Host des Homeservers
   */
  public subscribeHomeserverHost(callback: (host: string) => void) {
    return this.homeserverHostObservable?.subscribe(callback);
  }
}
